import {IconWrapperButtonProps, IconWrapperProps} from "app/Interface/Component/Icons"
import cls from "classnames"
import React from "react"

const wrapperClass = (wrapper: string, name: string, variant?: string, onClick?: () => void, active?: boolean, className?: string) => {
  return cls(
    `${wrapper}`,
    {
      [wrapper + '-' + variant]: variant,
      // [`${wrapper}-${size}`]: size !== 'default'
    },
    `sw-icon sw-icon--${name}`,
    {
      'active': active,
      'disabled': onClick === undefined,
    },
    className
  )
}

const IconWrapper = ({
                       id,
                       name,
                       variant,
                       children,
                       onClick,
                       style,
                       active = false,
                       wrapper = 'btn',
                       // size = 'default',
                       tabIndex = null,
                       className
                     }: IconWrapperProps) => {

  const cn = wrapperClass(wrapper, name, variant, onClick, active, className)

  if (wrapper === 'btn') {
    const button: IconWrapperButtonProps = {
      id: id,
      type: 'button',
      onClick: onClick,
      // onTouchStart: onClick,
      className: cn,
      style,
      children: children,
    }
    if (tabIndex)
      button.tabIndex = tabIndex

    return React.createElement('button', button)

  } else if (wrapper === 'span') {
    return (
      <span className={cn} onClick={onClick} id={id}>
        {children}
      </span>
    )
  } else
    return (
      <>
        {children}
      </>
    )
}

export default IconWrapper
